// extracted by mini-css-extract-plugin
export default {"root":"iYFXljbfovFrjhsE_0YO"};